/**
 * Dependencies
 *  - jQuery
 */
const WeCreate = {

	element: null,
	categoryButtons: null,
	we: null,
	descriptions: null,

	init: function (element) {
		this.element = element;
		this.categoryButtons = this.element.querySelectorAll('.category');
		this.we = this.element.querySelector('.we');
		this.descriptions = this.element.querySelectorAll('.description');


		this.categoryButtons.forEach(function (categoryButton) {
			categoryButton.addEventListener('click', this.select.bind(this));
		}.bind(this));

	},

	select: function (event) {
		this.categoryButtons.forEach((button) => {
			button.classList.remove('active');
		});
		this.descriptions.forEach((description) => {
			description.classList.remove('active');
		});
		const button = event.currentTarget;
		button.classList.add('active');
		const transform = Number.parseInt(button.dataset.index) * 25;
		this.we.style.transform = `translateY(${transform}%)`;
		this.descriptions.item(button.dataset.index).classList.add('active');
	},


}
export default WeCreate;
